import React, { useEffect, useState } from 'react';
import InputAdornment                 from '@mui/material/InputAdornment';
import TextField                      from '@mui/material/TextField';
import FileCopyIcon                   from '@mui/icons-material/FileCopy';
import IconButton                     from '@mui/material/IconButton';
import CheckIcon                      from '@mui/icons-material/Check';
import { useTranslation }             from 'react-i18next';
import Tooltip                        from '@mui/material/Tooltip';
import { Typography }                 from '@mui/material';
import { copyToClipboard }            from '../../utils/misc';

const ClipboardCopyTextField = ({ value, ...rest }) => {
	const [copied, setCopied] = useState(false);
	const { t } = useTranslation();

	useEffect(() => {
		let timer = null;
		if (copied) {
			timer = setTimeout(() => {
				setCopied(false);
			}, 1000);
		}
		return () => {
			if (timer) clearTimeout(timer);
		};
	}, [copied]);

	const handleCopy = () => {
		if (copied) return;
		copyToClipboard(value);
		setCopied(true);
	};

	return (
        <TextField
			value={value}
			InputProps={
				{
					endAdornment:
						(<InputAdornment position='end'>

							{!copied && <Tooltip title={t('clipboard_copy_tooltip')} placement='down' arrow={false}>
								<IconButton disabled={rest.disabled} onClick={handleCopy} size="large">
									<FileCopyIcon/>
								</IconButton>
							</Tooltip>}

							{copied && <>
								<CheckIcon color='primary'/>
								<Typography color='primary' variant='caption'>
									{t('clipboard_copy_confirm')}
								</Typography>

							</>}
						</InputAdornment>)
				}

			}

			{...rest}
		/>
    );
};

export default ClipboardCopyTextField;
